export const benefitItemsVer1 = [
  {
    icon: {name: 'talk', type: '40'},
    title: 'Curabitur lobortis id lorem id bibendum. Ut id consectetur.',
    description: 'Vestibulum rutrum quam vitae fringilla tincidunt. Suspendisse at condimentum nulla. Donec quis ornar nec tortor urna. Ut laoreet sodales nisi, quis iaculis nulla iaculis vitae. Donec sagittis faucibus lacus eget blandit. Mauris vitae ultricies metus, at condimentum nulla. Donec quis ornare lacus. Etiam gravida mollis tortor quis porttitor.',
  },
  {
    icon: {name: 'talk', type: '40'},
    title: 'Curabitur lobortis id lorem id bibendum. Ut id consectetur.',
    description: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Illum tenetur a quaerat ab suscipit minus magnam, nam maxime sequi eligendi quos pariatur repudiandae, temporibus commodi! Doloremque beatae quibusdam tempora aliquam.',
  },
  {
    icon: {name: 'talk', type: '40'},
    title: 'Curabitur lobortis id lorem id bibendum. Ut id consectetur.',
    description: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Illum tenetur a quaerat ab suscipit minus magnam, nam maxime sequi eligendi quos pariatur repudiandae, temporibus commodi! Doloremque beatae quibusdam tempora aliquam.',
  },
  {
    icon: {name: 'talk', type: '40'},
    title: 'Curabitur lobortis id lorem id bibendum. Ut id consectetur.',
    description: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Illum tenetur a quaerat ab suscipit minus magnam, nam maxime sequi eligendi quos pariatur repudiandae, temporibus commodi! Doloremque beatae quibusdam tempora aliquam.',
  },
];

export const benefitItemsVer2 = [
  {
    highlighted: 'Curabitur lobortis',
    title: 'id lorem id bibendum. Ut id consectetur.',
    description: 'Vestibulum rutrum quam vitae fringilla tincidunt. Suspendisse at condimentum nulla. Donec quis ornar nec tortor urna. Ut laoreet sodales nisi, quis iaculis nulla iaculis vitae. Donec sagittis faucibus lacus eget blandit. Mauris vitae ultricies metus, at condimentum nulla. Donec quis ornare lacus. Etiam gravida mollis tortor quis porttitor.',
  },
  {
    highlighted: 'Curabitur lobortis',
    title: 'id lorem id bibendum. Ut id consectetur.',
    description: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Illum tenetur a quaerat ab suscipit minus magnam, nam maxime sequi eligendi quos pariatur repudiandae, temporibus commodi! Doloremque beatae quibusdam tempora aliquam.',
  },
  {
    highlighted: 'Curabitur lobortis',
    title: 'id lorem id bibendum. Ut id consectetur.',
    description: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Illum tenetur a quaerat ab suscipit minus magnam, nam maxime sequi eligendi quos pariatur repudiandae, temporibus commodi! Doloremque beatae quibusdam tempora aliquam.',
  },
  {
    highlighted: 'Curabitur lobortis',
    title: 'id lorem id bibendum. Ut id consectetur.',
    description: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Illum tenetur a quaerat ab suscipit minus magnam, nam maxime sequi eligendi quos pariatur repudiandae, temporibus commodi! Doloremque beatae quibusdam tempora aliquam.',
  },
];


export const cardsTypeA = {
  cards: [
    {
      key: 'tab1',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab1',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab1',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'down',
      rate: '$ 000000'
    },
    {
      key: 'tab1',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab1',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab1',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'down',
      rate: '$ 000000'
    },
    {
      key: 'tab1',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'down',
      rate: '$ 000000'
    },
    {
      key: 'tab1',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab1',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab1',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab1',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab1',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab2',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab2',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab2',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab2',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab2',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab2',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab3',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab3',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab3',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab3',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab3',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab3',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab3',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    },
    {
      key: 'tab3',
      title: 'Eiusmo tempor',
      label: 'LABORIS ALIQUIP',
      flag: 'portugal',
      arrow: 'up',
      rate: '$ 000000'
    }
  ]
};

export const cardsTypeB = {
  cardTypeB: true,
  cards: [
    {
      key: 'tab1',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab1',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab1',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab1',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab1',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab1',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab2',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab2',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab2',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab2',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab2',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab3',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab3',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab3',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab3',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab3',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab3',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab3',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    },
    {
      key: 'tab3',
      title: 'Eiusmod tempor incididunt ut labore et dolore',
      info: 'Laboris nisi ut aliquip',
      icon: { icon: 'livechat', type: '40' }
    }
  ]
};

export const LandingSkinnyTypeA = {
  title: 'Lorem ipsum dolor',
  highlighted: 'sit amet, consectetur adipiscing elit.',
  items: [
    {
      icon: { icon: 'utilization', type: '80' },
      description: 'Ras egestas massa quis nunc laoree.'
    },
    {
      icon: { icon: 'utilization', type: '80' },
      description: 'Ras egestas massa quis nunc laoree.'
    },
    {
      icon: { icon: 'utilization', type: '80' },
      description: 'Ras egestas massa quis nunc laoree.'
    }
  ]
};

export const LandingSkinnyTypeB = {
  highlighted: 'Aliqam rutrum',
  title: 'hendrerit ipsum',
  description: {
    text: 'Aenean commodo dolor arcu, vel ornare tellus fringilla vel integer aliquet turpis.',
    link: 'ONLY TEXT',
    onClick: () => console.log('link was clicked')
  }
};

export const hubBannerItems = [
  {
    illustration: 'app-advisor',
    title: 'First',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    link: 'only text 12px',
    onClick: () => console.log('click callback')
  },
  {
    illustration: 'smartphone-action',
    title: 'Nostrud Exercitation',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    link: 'only text 12px',
    onClick: () => console.log('click callback')
  },
  {
    illustration: 'app-advisor',
    title: 'Hospitality',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    link: 'only text 12px',
    onClick: () => console.log('click callback')
  },
  {
    illustration: 'app-advisor',
    title: 'Hospitality',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    link: 'only text 12px',
    onClick: () => console.log('click callback')
  },
  {
    illustration: 'smartphone-action',
    title: 'Nostrud Exercitation',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    link: 'only text 12px',
    onClick: () => console.log('click callback')
  },
  {
    illustration: 'app-advisor',
    title: 'Hospitality',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    link: 'only text 12px',
    onClick: () => console.log('click callback')
  },
  {
    illustration: 'app-advisor',
    title: 'Hospitality',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    link: 'only text 12px',
    onClick: () => console.log('click callback')
  },
  {
    illustration: 'smartphone-action',
    title: 'Nostrud Exercitation',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    link: 'only text 12px',
    onClick: () => console.log('click callback')
  },
  {
    illustration: 'app-advisor',
    title: 'Hospitality',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    link: 'only text 12px',
    onClick: () => console.log('click callback')
  }
];

const testimonialsText = 'Airtel Business team delivers excellent support and high class services that has been critical to our business performance. Both the organizations are maximizing opportunities across Voice, Data, Mobile Solutions and Network Infrastructure. We see them as trusted partner for Emerging Markets and India centric needs. We highly recommend Airtel Business as suitable partner for a continued successful collaborative working relationship.';

export const testimonialsData = [
  {
    imageUrl: 'path/to/img',
    title: 'Our network',
    text: testimonialsText,
    author: 'Pierre-Louis de Guillebon',
    authorDesc: 'Managing Director Orange, International Carriers'
  },
  {
    imageUrl: 'path/to/image',
    title: 'Our network',
    text: testimonialsText,
    author: 'Antoine-Louis de Guillebon',
    authorDesc: 'Managing Director Orange, International Carriers'
  },
  {
    imageUrl: 'path/to/img',
    title: 'Our network',
    text: testimonialsText,
    author: 'Julio-Louis de Guillebon',
    authorDesc: 'Managing Director Orange, International Carriers'
  },
  {
    imageUrl: 'path/to/image',
    title: 'Our network',
    text: testimonialsText,
    author: 'George-Louis de Guillebon',
    authorDesc: 'Managing Director Orange, International Carriers'
  }
];

export const carouselSlidesA = [
  {
    imageUrl: 'path/to/img',
    label: 'Case Study',
    title: 'Luminous converted their inverters into smart devices.',
    description: 'Our extensive network of undersea cables and peering partners worldwide enable path optimisation.',
    onButtonClick: () => console.log('button was clicked'),
    buttonText: 'Learn more'
  },
  {
    imageUrl: 'path/to/image',
    label: 'Case Study',
    title: 'Lorem converted their inverters into smart devices.',
    description: 'Our extensive network of undersea cables and peering partners worldwide enable path optimisation.',
    onButtonClick: () => console.log('button was clicked'),
    buttonText: 'Learn more'
  },
  {
    imageUrl: 'path/to/img',
    label: 'Case Study',
    title: 'Luminous converted their inverters into smart devices.',
    description: 'Our extensive network of undersea cables and peering partners worldwide enable path optimisation.',
    onButtonClick: () => console.log('button was clicked'),
    buttonText: 'Learn more'
  },
  {
    imageUrl: 'path/to/image',
    label: 'Case Study',
    title: 'Lorem converted their inverters into smart devices.',
    description: 'Our extensive network of undersea cables and peering partners worldwide enable path optimisation.',
    onButtonClick: () => console.log('button was clicked'),
    buttonText: 'Learn more'
  },
];

export const carouselSlidesB = [
  {
    imageUrl: 'path/to/img',
    label: 'Case Study',
    highlighted: 'High-speed',
    title: 'Corporate Internet Access.',
    description: 'Our extensive network of undersea cables and peering partners worldwide enable path optimisation.',
    onButtonClick: () => console.log('button was clicked'),
    buttonText: 'Learn more'
  },
  {
    imageUrl: 'path/to/image',
    label: 'Case Study',
    highlighted: 'High-speed',
    title: 'Corporate Internet Access.',
    description: 'Our extensive network of undersea cables and peering partners worldwide enable path optimisation.',
    onButtonClick: () => console.log('button was clicked'),
    buttonText: 'Learn more'
  },
  {
    imageUrl: 'path/to/img',
    label: 'Case Study',
    highlighted: 'High-speed',
    title: 'Corporate Internet Access.',
    description: 'Our extensive network of undersea cables and peering partners worldwide enable path optimisation.',
    onButtonClick: () => console.log('button was clicked'),
    buttonText: 'Learn more'
  },
  {
    imageUrl: 'path/to/image',
    label: 'Case Study',
    highlighted: 'High-speed',
    title: 'Corporate Internet Access.',
    description: 'Our extensive network of undersea cables and peering partners worldwide enable path optimisation.',
    onButtonClick: () => console.log('button was clicked'),
    buttonText: 'Learn more'
  },
];

export const articlesArray = [
  {
    imgUrl: 'path/to/image',
    title: 'Lorem ipsum dolor 1 am.',
    articleDate: 'May 12, 2017 under',
    dateHighlight: 'Knowledge Hub',
    description: 'Nam dapibus nisl vitae elit fringilla rutrum. Aenean sollicitudin, erat a elementum rutrum, neque sem pretium metus, quis mollis nisl nunc et massa. Vestibulum sed.',
    link: 'read more',
    onClick: () => console.log('link clicked')
  },
  {
    imgUrl: 'path/to/image',
    title: 'Lorem ipsum dolor 2 am.',
    articleDate: 'May 12, 2017 under',
    dateHighlight: 'Knowledge Hub',
    description: 'Nam dapibus nisl vitae elit fringilla rutrum. Aenean sollicitudin, erat a elementum rutrum, neque sem pretium metus, quis mollis nisl nunc et massa. Vestibulum sed.',
    link: 'read more',
    onClick: () => console.log('link clicked')
  },
  {
    imgUrl: 'path/to/image',
    title: 'Lorem ipsum dolor 3 am.',
    articleDate: 'May 12, 2017 under',
    dateHighlight: 'Knowledge Hub',
    description: 'Nam dapibus nisl vitae elit fringilla rutrum. Aenean sollicitudin, erat a elementum rutrum, neque sem pretium metus, quis mollis nisl nunc et massa. Vestibulum sed.',
    link: 'read more',
    onClick: () => console.log('link clicked')
  },
  {
    imgUrl: 'path/to/image',
    title: 'Lorem ipsum dolor 4 am.',
    articleDate: 'May 12, 2017 under',
    dateHighlight: 'Knowledge Hub',
    description: 'Nam dapibus nisl vitae elit fringilla rutrum. Aenean sollicitudin, erat a elementum rutrum, neque sem pretium metus, quis mollis nisl nunc et massa. Vestibulum sed.',
    link: 'read more',
    onClick: () => console.log('link clicked')
  }
];

export const articlesArrayB = [
  {
    imgUrl: 'path/to/image',
    section: 'Leadership Articles',
    year: 2017,
    title: 'Lorem ipsum dolor 1 am.',
    articleDate: 'May 12, 2017 under',
    dateHighlight: 'Knowledge Hub',
    description: 'Nam dapibus nisl vitae elit fringilla rutrum. Aenean sollicitudin, erat a elementum rutrum, neque sem pretium metus, quis mollis nisl nunc et massa. Vestibulum sed.',
    link: 'read more',
    onClick: () => console.log('link clicked')
  },
  {
    imgUrl: 'path/to/image',
    section: 'Leadership Articles',
    year: 2018,
    title: 'Lorem ipsum dolor 2 am.',
    articleDate: 'May 12, 2017 under',
    dateHighlight: 'Knowledge Hub',
    description: 'Nam dapibus nisl vitae elit fringilla rutrum. Aenean sollicitudin, erat a elementum rutrum, neque sem pretium metus, quis mollis nisl nunc et massa. Vestibulum sed.',
    link: 'read more',
    onClick: () => console.log('link clicked')
  },
  {
    imgUrl: 'path/to/image',
    section: 'Leadership Articles',
    year: 2017,
    title: 'Lorem ipsum dolor 1 am.',
    articleDate: 'May 12, 2017 under',
    dateHighlight: 'Knowledge Hub',
    description: 'Nam dapibus nisl vitae elit fringilla rutrum. Aenean sollicitudin, erat a elementum rutrum, neque sem pretium metus, quis mollis nisl nunc et massa. Vestibulum sed.',
    link: 'read more',
    onClick: () => console.log('link clicked')
  },
  {
    imgUrl: 'path/to/image',
    section: 'Leadership Articles',
    year: 2018,
    title: 'Lorem ipsum dolor 2 am.',
    articleDate: 'May 12, 2017 under',
    dateHighlight: 'Knowledge Hub',
    description: 'Nam dapibus nisl vitae elit fringilla rutrum. Aenean sollicitudin, erat a elementum rutrum, neque sem pretium metus, quis mollis nisl nunc et massa. Vestibulum sed.',
    link: 'read more',
    onClick: () => console.log('link clicked')
  },
  {
    imgUrl: 'path/to/image',
    section: 'Leadership Articles',
    year: 2017,
    title: 'Lorem ipsum dolor 1 am.',
    articleDate: 'May 12, 2017 under',
    dateHighlight: 'Knowledge Hub',
    description: 'Nam dapibus nisl vitae elit fringilla rutrum. Aenean sollicitudin, erat a elementum rutrum, neque sem pretium metus, quis mollis nisl nunc et massa. Vestibulum sed.',
    link: 'read more',
    onClick: () => console.log('link clicked')
  },
  {
    imgUrl: 'path/to/image',
    section: 'Leadership Articles',
    year: 2018,
    title: 'Lorem ipsum dolor 2 am.',
    articleDate: 'May 12, 2017 under',
    dateHighlight: 'Knowledge Hub',
    description: 'Nam dapibus nisl vitae elit fringilla rutrum. Aenean sollicitudin, erat a elementum rutrum, neque sem pretium metus, quis mollis nisl nunc et massa. Vestibulum sed.',
    link: 'read more',
    onClick: () => console.log('link clicked')
  },
  { 

    imgUrl: 'path/to/image',
    section: 'Case Studies',
    year: 2017,
    title: 'Lorem ipsum dolor 3 am.',
    articleDate: 'May 12, 2017 under',
    dateHighlight: 'Knowledge Hub',
    description: 'Nam dapibus nisl vitae elit fringilla rutrum. Aenean sollicitudin, erat a elementum rutrum, neque sem pretium metus, quis mollis nisl nunc et massa. Vestibulum sed.',
    link: 'read more',
    onClick: () => console.log('link clicked')
  },
  {
    imgUrl: 'path/to/image',
    section: 'Case Studies',
    year: 2018,
    title: 'Lorem ipsum dolor 4 am.',
    articleDate: 'May 12, 2017 under',
    dateHighlight: 'Knowledge Hub',
    description: 'Nam dapibus nisl vitae elit fringilla rutrum. Aenean sollicitudin, erat a elementum rutrum, neque sem pretium metus, quis mollis nisl nunc et massa. Vestibulum sed.',
    link: 'read more',
    onClick: () => console.log('link clicked')
  },
  {
    imgUrl: 'path/to/image',
    section: 'Leadership Articles',
    year: 2017,
    title: 'Lorem ipsum dolor 1 am.',
    articleDate: 'May 12, 2017 under',
    dateHighlight: 'Knowledge Hub',
    description: 'Nam dapibus nisl vitae elit fringilla rutrum. Aenean sollicitudin, erat a elementum rutrum, neque sem pretium metus, quis mollis nisl nunc et massa. Vestibulum sed.',
    link: 'read more',
    onClick: () => console.log('link clicked')
  },
  {
    imgUrl: 'path/to/image',
    section: 'Leadership Articles',
    year: 2018,
    title: 'Lorem ipsum dolor 2 am.',
    articleDate: 'May 12, 2017 under',
    dateHighlight: 'Knowledge Hub',
    description: 'Nam dapibus nisl vitae elit fringilla rutrum. Aenean sollicitudin, erat a elementum rutrum, neque sem pretium metus, quis mollis nisl nunc et massa. Vestibulum sed.',
    link: 'read more',
    onClick: () => console.log('link clicked')
  },
  { 

    imgUrl: 'path/to/image',
    section: 'Case Studies',
    year: 2017,
    title: 'Lorem ipsum dolor 3 am.',
    articleDate: 'May 12, 2017 under',
    dateHighlight: 'Knowledge Hub',
    description: 'Nam dapibus nisl vitae elit fringilla rutrum. Aenean sollicitudin, erat a elementum rutrum, neque sem pretium metus, quis mollis nisl nunc et massa. Vestibulum sed.',
    link: 'read more',
    onClick: () => console.log('link clicked')
  },
  {
    imgUrl: 'path/to/image',
    section: 'Case Studies',
    year: 2018,
    title: 'Lorem ipsum dolor 4 am.',
    articleDate: 'May 12, 2017 under',
    dateHighlight: 'Knowledge Hub',
    description: 'Nam dapibus nisl vitae elit fringilla rutrum. Aenean sollicitudin, erat a elementum rutrum, neque sem pretium metus, quis mollis nisl nunc et massa. Vestibulum sed.',
    link: 'read more',
    onClick: () => console.log('link clicked')
  }
];

export const getMediaBannerData = (version) => (
  [
    {
      highlighted: 'Curabitur lobs id lorem',
      title: 'Curabitur',
      description: 'Mauris non tempor quam, et lacinia sapien. Mauris accumsan eros eget libero posuere vulputate. Etiam elit elit, elementum sed varius at, adipiscing vitae est. Sed nec felis pellentesque, lacinia dui sed, ultricies sapien. Pellentesque.',
      youtubeVideoId: 'sJE6GV9TmOk',
      thumbnail: 'http://img.youtube.com/vi/sJE6GV9TmOk/maxresdefault.jpg',
      steps: version === 2 ? [{ icon: { icon: 'recharges', type: '30' }, description: 'In hac habita.' },{ icon: { icon: 'recharges', type: '30' }, description: 'In hac habita.' },{ icon: { icon: 'recharges', type: '30' }, description: 'In hac habita.' }] : null
    },
    {
      highlighted: 'Curabitur lobs id lorem',
      title: 'Curabitur',
      description: 'Mauris non tempor quam, et lacinia sapien. Mauris accumsan eros eget libero posuere vulputate. Etiam elit elit, elementum sed varius at, adipiscing vitae est. Sed nec felis pellentesque, lacinia dui sed, ultricies sapien. Pellentesque.',
      youtubeVideoId: 'kAznA6cFErw',
      thumbnail: 'http://img.youtube.com/vi/kAznA6cFErw/maxresdefault.jpg',
      steps: version === 2 ? [{ icon: { icon: 'recharges', type: '30' }, description: 'In hac habita.' },{ icon: { icon: 'recharges', type: '30' }, description: 'In hac habita.' },{ icon: { icon: 'recharges', type: '30' }, description: 'In hac habita.' }] : null
    },
    {
      highlighted: 'Curabitur lobs id lorem',
      title: 'Curabitur',
      description: 'Mauris non tempor quam, et lacinia sapien. Mauris accumsan eros eget libero posuere vulputate. Etiam elit elit, elementum sed varius at, adipiscing vitae est. Sed nec felis pellentesque, lacinia dui sed, ultricies sapien. Pellentesque.',
      youtubeVideoId: 'sJE6GV9TmOk',
      thumbnail: 'http://img.youtube.com/vi/sJE6GV9TmOk/maxresdefault.jpg',
      steps: version === 2 ? [{ icon: { icon: 'recharges', type: '30' }, description: 'In hac habita.' },{ icon: { icon: 'recharges', type: '30' }, description: 'In hac habita.' },{ icon: { icon: 'recharges', type: '30' }, description: 'In hac habita.' }] : null
    },
    {
      highlighted: 'Curabitur lobs id lorem',
      title: 'Curabitur',
      description: 'Mauris non tempor quam, et lacinia sapien. Mauris accumsan eros eget libero posuere vulputate. Etiam elit elit, elementum sed varius at, adipiscing vitae est. Sed nec felis pellentesque, lacinia dui sed, ultricies sapien. Pellentesque.',
      youtubeVideoId: 'kAznA6cFErw',
      thumbnail: 'http://img.youtube.com/vi/kAznA6cFErw/maxresdefault.jpg',
      steps: version === 2 ? [{ icon: { icon: 'recharges', type: '30' }, description: 'In hac habita.' },{ icon: { icon: 'recharges', type: '30' }, description: 'In hac habita.' },{ icon: { icon: 'recharges', type: '30' }, description: 'In hac habita.' }] : null
    }
  ]
);


// WEBPACK FOOTER //
// ./src/containers/components/Banner/constants/bannersData.js